import React from "react";
import { Card } from "@material-ui/core";

import ManagementTab from "../../containers/WorkTab/ManagementTab";

const tabList = [
  { key: "scientificResearch", title: "Bài báo" },
  { key: "solution", title: "Giải pháp hữu ích" },
  { key: "patent", title: "Bằng sáng chế" },
  { key: "project", title: "Đề tài nghiên cứu" },
  { key: "monograph", title: "Sách/Chương sách" },
  { key: "exhibition", title: "Triển lãm" },
  { key: "achievement", title: "Giải thưởng" },
  { key: "studentGuidance", title: "Hướng dẫn SV NCKH" },
  { key: "scientificCouncilNew", title: "Hội đồng khoa học" },
];

const height = "calc(100vh - 92px)";

function Management() {
  return (
    <Card
      style={{
        height: height,
        minHeight: height,
        maxHeight: height,
        position: "relative",
      }}
    >
      <ManagementTab tabList={tabList} />
    </Card>
  );
}

export default Management;

